import {
  Datagrid,
  FunctionField,
  ReferenceField,
  ReferenceManyField,
  TextField,
  type RaRecord,
} from "react-admin";
import { formatDisplayDateTime } from "@/utils/date-format";
import { formatSabilAuditActionLabel } from "../format-sabil-audit-action-label";

const ChangeHistory = () => (
  <ReferenceManyField
    reference="sabilAudit"
    target="refId"
    label={false}
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <FunctionField
        label="When"
        sortBy="createdAt"
        render={(record: RaRecord) => formatDisplayDateTime(record?.createdAt, { empty: "—" })}
      />
      <ReferenceField source="createdBy" reference="admins" link={false} emptyText="—">
        <TextField source="name" />
      </ReferenceField>
      <FunctionField
        label="Action"
        sortBy="actionType"
        render={(record: RaRecord) => formatSabilAuditActionLabel(record?.actionType as string)}
      />
      <TextField source="remarks" label="Details" />
    </Datagrid>
  </ReferenceManyField>
);

export default ChangeHistory;
